var map = {
	"./blog.yml": 164,
	"./cloud.yml": 165,
	"./color.yml": 166,
	"./country.yml": 167,
	"./dio.yml": 168,
	"./doc.yml": 169,
	"./emoji.yml": 170,
	"./git.yml": 171,
	"./icon.yml": 172,
	"./license.yml": 173,
	"./link.yml": 174,
	"./metrics.yml": 175,
	"./people.yml": 176,
	"./soft.yml": 177,
	"./src.yml": 178,
	"./status.yml": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;